import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Profile } from './profile.model';
import { UsersService } from '../users/users.service';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  canCreateTemplates = false;
  asperaClientMode = 'connect';
  savedAsperaClientMode = 'connect';
  saving = false;

  constructor(private usersService: UsersService, public snackBar: MatSnackBar) { }

  ngOnInit() {
    this.usersService.profile.subscribe((profile) => {
      this.canCreateTemplates = profile.canCreateTemplates;
      this.asperaClientMode = profile.asperaClientMode || 'connect';
      this.savedAsperaClientMode = this.asperaClientMode;
    });
  }

  updateAsperaClientMode() {
    const storedProfileJson = localStorage.getItem('userProfile');
    if (storedProfileJson == null) { return; }
    let storedProfile: Profile;
    try {
      storedProfile = JSON.parse(storedProfileJson) as Profile;
    } catch (e) {
      console.error('Could not parse stored profile', e);
      this.snackBar.open('Could not save Aspera client mode', 'Dismiss', { duration: 5000, verticalPosition: 'top' });
      return;
    }

    storedProfile.asperaClientMode = this.asperaClientMode;

    const setting = storedProfile.settings.find(s => s.setting_name === 'aspera_client_mode');
    if (setting) {
      setting.setting_value = this.asperaClientMode;
    } else {
      storedProfile.settings.push({setting_name: 'aspera_client_mode', setting_value: this.asperaClientMode});
    }

    this.saving = true;
    this.usersService.updateProfile(storedProfile).subscribe(
      () => {
        this.saving = false;
        this.savedAsperaClientMode = this.asperaClientMode;
        // Show a confirmation toast, then reload once it closes. The SDK picks
        // its transfer client at page load, so a reload applies the change.
        this.snackBar.open(`Aspera client mode '${this.asperaClientMode}' saved`, 'Dismiss', { duration: 3000, verticalPosition: 'top' })
          .afterDismissed().subscribe(() => window.location.reload());
      },
      (error) => {
        this.saving = false;
        console.error('Could not save Aspera client mode: ', error);
        this.snackBar.open('Could not save Aspera client mode', 'Dismiss', { duration: 5000, verticalPosition: 'top' });
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/users/settings.component.ts